import React from 'react'

export const MdiUsers = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="none" viewBox="0 0 22 22">
      <path
        fill="#000"
        d="M14.667 15.583v1.834H1.833v-1.834s0-3.666 6.417-3.666 6.417 3.666 6.417 3.666zm-3.209-8.708a3.209 3.209 0 10-6.417 0 3.209 3.209 0 006.417 0zm3.154 5.042a4.875 4.875 0 011.888 3.666v1.834h3.667v-1.834s0-3.327-5.555-3.666zm-.862-8.25a3.108 3.108 0 00-1.77.54 4.583 4.583 0 010 5.336 3.107 3.107 0 001.77.54 3.208 3.208 0 100-6.416z"
      ></path>
    </svg>
  )
}
